import styled from "@emotion/styled";
import { css } from "@emotion/react";
import {
  grayScale,
  mBody1,
  mBody2,
  mBody4,
  mTitle2,
  sparta,
  swc,
} from "@teamsparta/design-system";
import { DESKTOP, lnbAndFloating } from "@/themes/device";

export const Wrapper = styled.nav`
  transition: all 0.4s ease;
  position: relative;
  ${DESKTOP} {
    display: none;
  }
`;

export const Toggle = styled.div`
  flex-direction: column;
  transition: all 0.4s ease;
  cursor: pointer;
`;

const Stick = css`
  width: 18px;
  height: 2px;
  background-color: ${grayScale.gray100};
  border-radius: 16px;
  transform-origin: 0.6px;
`;

export const FirstStick = styled.div<{ isSideMenuOpen: boolean }>`
  ${Stick};
  transform: ${({ isSideMenuOpen }) =>
    isSideMenuOpen ? "rotate(45deg)" : "rotate(0)"};
  margin-bottom: 4px;
  transition: all 0.3s linear;
`;
export const SecondStick = styled.div<{ isSideMenuOpen: boolean }>`
  ${Stick};
  transform: ${({ isSideMenuOpen }) =>
    isSideMenuOpen ? "translateX(100%)" : "translateX(0)"};
  opacity: ${({ isSideMenuOpen }) => (isSideMenuOpen ? 0 : 1)};
  margin-bottom: 4px;
`;
export const ThirdStick = styled.div<{ isSideMenuOpen: boolean }>`
  ${Stick};
  transform: ${({ isSideMenuOpen }) =>
    isSideMenuOpen ? "rotate(-45deg)" : "rotate(0)"};
  transition: all 0.3s linear;
`;

export const Menu = styled.div<{ isSideMenuOpen: boolean }>`
  width: 100vw;
  height: 100vh;
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  transition: transform 0.3s cubic-bezier(0, 0.52, 0, 1);
  overflow: hidden;
  z-index: 120;
  transform: ${({ isSideMenuOpen }) =>
    isSideMenuOpen ? "translate3d(0vw, 0, 0)" : "translate3d(100vw, 0, 0)"};
  margin-top: 50px;
`;

export const MenuList = styled.ul`
  width: 328px;
  list-style: none;
  padding: 0;
  margin: 0 auto;
`;

export const LoginStatusBtn = styled.div<{ isLoggedIn?: boolean }>`
  width: 100%;
  ${mTitle2};
  color: ${grayScale.gray100};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ isLoggedIn }) => (isLoggedIn ? "" : "pointer")};
  margin-top: 59.5px;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${grayScale.gray20};
  margin: 30px 0;
`;

export const Items = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const Item = styled.li<{ isClicked?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${mBody2};
  color: ${grayScale.gray90};
  cursor: pointer;
`;

export const ItemText = styled.b<{ isClicked: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: ${({ isClicked }) => (isClicked ? "bold" : "normal")};
`;

export const RoundInfoBadge = styled.small<{ isAlimStep: boolean }>`
  ${mBody4}
  font-size: 11px;
  padding: 2px 8px;
  background-color: ${({ isAlimStep }) =>
    isAlimStep ? grayScale.gray10 : sparta.blue10};
  color: ${({ isAlimStep }) => (isAlimStep ? grayScale.gray80 : swc.blue)};
  border-radius: 100px;
  margin-left: 8px;
`;

export const Logout = styled.div`
  ${mBody1};
  cursor: pointer;
  color: ${grayScale.gray70};
  position: absolute;
  bottom: 30%;
  left: calc((100% - 48.41px) / 2);
`;
